import React, { Component } from 'react';
import cross from '../../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import message from '../../../data/Message.json';
import AlertModal from '../../shared/AlertModal';
import Upload from '../../shared/Upload';
import '../../../css/advertisement/AdvertisementData.css';
import SubmitModal from '../../shared/SuccessModal';
import Calendar from 'react-calendar';
import Loader from 'react-loader';
// import { store } from '../../../redux/_helpers/store';
// import {successLoader} from '../../../redux/_actions/loader.action';
import 'react-calendar/dist/Calendar.css';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { UPDATEADDVERTISEMENT_ENDPOINT, ADVERTISEMENTSLOT_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let isSlotAvailable = false;
class EditAdvertisementData extends Component {
  constructor(props) {
    super(props)
    this.container = React.createRef();
    this.state = {
      publishHasOpen: false,
      url: '',
      effectiveDateCalendar: new Date(),
      expiryDateCalendar: new Date(),
      showEffectiveCalendar: false,
      showExpiryCalendar: false,
      advertisementData: this.props.advertisementData,
      editIndex: this.props.editIndex,
      advertisementName: '',
      imageUploadLink: '',
      imageLink: '',
      isUploadDisabled: true,
      isDeleteDisabled: false,
      effectiveDate: '',
      expiryDate: '',
      errors: {},
      effectiveDateCopy: "",
      expiryDateCopy: "",
      hasOpenAlert: false,
      advertisementSlot: [],
      effectiveDateFormateCopy: '',
      loaderTime: true,
      pageDisable: true,
    }
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleClickOutside);
    ApiCall(
      'GET',
      utilityBaseURL + ADVERTISEMENTSLOT_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ' x-cc-trace-id': '1234',
      },
    ).then((apiData) => {
      if (apiData.flag !== -1) {
        if (apiData.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          console.log(apiData);
          this.setState({ advertisementSlot: apiData });
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
    this.setState({ advertisementName: this.state.advertisementData[this.state.editIndex]?.aDCompany });
    this.setState({ url: this.state.advertisementData[this.state.editIndex]?.aDLink });
    this.setState({ effectiveDateCalendar: this.getDate(this.state.advertisementData[this.state.editIndex]?.fromDate) });
    this.setState({ effectiveDateCopy: this.state.advertisementData[this.state.editIndex]?.fromDate });
    this.setState({ expiryDateCopy: this.state.advertisementData[this.state.editIndex]?.toDate });
    this.setState({ expiryDateCalendar: this.getDate(this.state.advertisementData[this.state.editIndex]?.toDate) });
    this.setState({ imageLink: this.props.decodeUrl });
    this.setState({ imageUploadLink: this.state.advertisementData[this.state.editIndex]?.aDImageMobileLink });
    let fromDateParts = this.state.advertisementData[this.state.editIndex]?.fromDate.split("/");
    let fromDateFormate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]).toString();
    this.setState({ effectiveDateFormateCopy: fromDateFormate })
    // this.state.imageLink !== undefined ? store.dispatch(successLoader(true)) : store.dispatch(successLoader(false));
    this.setState({ loaderTime: this.state.imageLink !== undefined ? false : true, pageDisable: this.state.imageLink !== undefined ? false : true })
  }
  componentWillReceiveProps(nextProps) {
    // this.state.imageLink !== undefined ? store.dispatch(successLoader(true)) : store.dispatch(successLoader(false));
    this.setState({ loaderTime: this.state.imageLink !== undefined ? false : true, pageDisable: this.state.imageLink !== undefined ? false : true })
    this.setState({ imageLink: this.props.decodeUrl });
    console.log('componentWillReceiveProps', nextProps);
    this.setState(nextProps);
  }
  getTime = (timeStamp) => {
    return new Date(Number(timeStamp)).toString().split(' ')[4].substring(0, 5);
  }
  getDate = (dateString) => {
    //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
    let dateParts = dateString.split("/");
    // month is 0-based, that's why we need dataParts[1] - 1
    let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
    // let date = new Date(Number(dateString)).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  getDateFormate = (dateString) => {
    let date = new Date(Number(dateString)).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  setImageUploadLink = (imagePathURL) => {
    this.setState({ imageUploadLink: imagePathURL })
  }
  removeImageUploadedLink = () => {
    this.setState({ imageUploadLink: '' })
  }
  onPublish = () => {
    this.setState({ publishHasOpen: false })
    this.props.onClosePublish()
  }
  onhandlePublish = () => {
    let fromTimeStamp = new Date(this.state.effectiveDateCalendar);
    let toTimeStamp = new Date(this.state.expiryDateCalendar);
    console.log(fromTimeStamp, toTimeStamp)
    fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(fromTimeStamp).toString().substring(0, 10));
    toTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(toTimeStamp).toString().substring(0, 10));
    ApiCall(
      'PUT',
      utilityBaseURL + UPDATEADDVERTISEMENT_ENDPOINT,
      {
        "aDCompany": this.state.advertisementName,
        "aDId": this.state.advertisementData[this.state.editIndex]?.aDId,
        "aDImageMobileLink": this.state.imageUploadLink,
        "aDImageWebLink": this.state.imageUploadLink,
        "aDLink": this.state.url,
        "fromDate": fromTimeStamp,
        "toDate": toTimeStamp,
      },
      {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-cc-trace-id': '1234',
      }
    ).then(data => {
      if (data.flag !== -1) {
        if (data.flag === 500) {
          if (data.data.errors.TPT0004) {
            this.setState({ hasOpenAlert: true })
          }
          else {
            toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
          }
        }
        else {
          console.log('I am 200!');
          this.setState({ publishHasOpen: true })
        }
      }
      else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    })
  }
  handleSubmit = () => {
    console.log("check dot", this.state.url.charAt(this.state.url.length - 1));
    if (this.handleValidation()) {
      console.log("submit")
      this.onhandlePublish();
    }
  }
  handleValidation() {
    // DD/MM/YYYY DATE FORMATE
    let fromDateParts = this.state.effectiveDateCopy.split("/");
    let fromDateFormate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]).toString();
    let toDateParts = this.state.expiryDateCopy.split("/");
    let toDateFormate = new Date(toDateParts[2], toDateParts[1] - 1, toDateParts[0]).toString();
    let toDate = this.state.expiryDate.length !== 0 ? new Date(Number(this.state.expiryDate)).getDate() : new Date(toDateFormate).getDate()
    let fromDate = this.state.effectiveDate.length !== 0 ? new Date(Number(this.state.effectiveDate)).getDate() : (new Date(fromDateFormate)).getDate()
    let toMonth = this.state.expiryDate.length !== 0 ? new Date(Number(this.state.expiryDate)).getMonth() : (new Date(toDateFormate)).getMonth()
    let fromMonth = this.state.effectiveDate.length !== 0 ? new Date(Number(this.state.effectiveDate)).getMonth() : (new Date(fromDateFormate)).getMonth()
    let toYear = this.state.expiryDate.length !== 0 ? new Date(Number(this.state.expiryDate)).getFullYear() : (new Date(toDateFormate)).getFullYear()
    let fromYear = this.state.effectiveDate.length !== 0 ? new Date(Number(this.state.effectiveDate)).getFullYear() : (new Date(fromDateFormate)).getFullYear()
    let errors = {};
    let formIsValid = true;
    let patternCharacter = new RegExp(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/);
    if (!patternCharacter.test(this.state.url)) {
      formIsValid = false;
      errors["url"] = message.validation.validUrl;
    }
    // if (!this.getAvailablity()) {
    //   formIsValid = false;
    //   this.setState({ hasOpenAlert: true })
    // }
    if (fromYear > toYear) {
      formIsValid = false;
      errors["todate"] = message.validation.date;
    }
    else if (fromYear === toYear) {
      if (fromMonth > toMonth) {
        formIsValid = false;
        errors["todate"] = message.validation.date;
      }
      else if (fromMonth === toMonth) {
        if (fromDate > toDate) {
          formIsValid = false;
          errors["todate"] = message.validation.date;
        }
      }
    }
    this.setState({ errors: errors });
    return formIsValid;
  }
  onCloseAlert = () => {
    this.setState({ hasOpenAlert: false })
  }
  getTileStatus = (tileDate, tileMonth) => {
    let checkSlot = false;
    this.state.advertisementSlot.map(
      slotAvailable => {
        let x = slotAvailable.adDate
        let dateParts = x.split("/");
        let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
        if (tileDate === date.getDate() && tileMonth === date.getMonth() && slotAvailable.slotAvailable === 0) {
          checkSlot = true
        }
        return true;
      })
    return checkSlot
  }
  getAvailablity = () => {
    // DD/MM/YYYY DATE FORMATE
    let fromDateParts = this.state.effectiveDateCopy.split("/");
    let fromDateFormate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]).toString();
    let toDateParts = this.state.expiryDateCopy.split("/");
    let toDateFormate = new Date(toDateParts[2], toDateParts[1] - 1, toDateParts[0]).toString();
    let toDate = this.state.expiryDate.length !== 0 ? new Date(Number(this.state.expiryDate)).getTime() : new Date(toDateFormate).getTime()
    let fromDate = this.state.effectiveDate.length !== 0 ? new Date(Number(this.state.effectiveDate)).getTime() : (new Date(fromDateFormate)).getTime()
    let count = 0;
    let time_difference = toDate - fromDate;
    let days_difference = time_difference / (1000 * 60 * 60 * 24);
    // WHILE LOOP
    var loop = new Date(fromDate);
    while (loop <= new Date(toDate)) {
      if (this.getTileStatus(loop.getDate(), loop.getMonth())) {
        break;
      }
      count = count + 1;
      var newDate = loop.setDate(loop.getDate() + 1);
      loop = new Date(newDate);
    }
    let checkSlots = days_difference + 1;
    checkSlots = Math.floor(checkSlots);
    if (checkSlots === count) {
      isSlotAvailable = true;
    }
    else {
      isSlotAvailable = false;
    }
    return isSlotAvailable;
  }

  handleUrl = (e) => {
    this.setState({
      url: e.target.value,
      errors: {
        ...this.state.errors,
        url: ''
      }
    })
  }
  //formDate
  handleEffectiveDateChanged = (e) => {
    this.setState({
      effectiveDateCalendar: this.getDateFormate(e),
      effectiveDate: new Date(Number(e)),
      showEffectiveCalendar: false,
      errors: {
        ...this.state.errors,
        todate: ''
      }
    });
  }
  toggleEffectiveCalendar = () => {
    this.setState({ showEffectiveCalendar: !this.showEffectiveCalendar });
  }
  //toDate
  handleExpiryDateChanged = (e) => {
    this.setState({
      expiryDateCalendar: this.getDateFormate(e),
      expiryDate: new Date(Number(e)),
      showExpiryCalendar: false,
      errors: {
        ...this.state.errors,
        todate: ''
      }
    });
  }
  toggleExpiryCalendar = () => {
    this.setState({ showExpiryCalendar: !this.showExpiryCalendar });
  }
  handleClickOutside = event => {
    if (this.container.current && !this.container.current.contains(event.target)) {
      this.setState({ showEffectiveCalendar: false });
      this.setState({ showExpiryCalendar: false });
    }
  };
  validateFormFields = () => {
    return this.state.advertisementName.length > 0 &&
      this.state.url.length > 0 &&
      this.state.imageUploadLink.length > 0
  };
  render() {
    return (
      <div class="advertisementModalOuter" id={this.state.pageDisable ? "disabletrue" : ""}>
        <MetaDecorator title={TitleDescription.editAdvertisementDataPageTitle} description={TitleDescription.editAdvertisementDataPageDescription} />
        <div class="advertisementModalInner" >
          <Loader
            loaded={!this.state.loaderTime}
            lines={10}
            length={10}
            width={10}
            radius={10}
            corners={1}
            rotate={0}
            direction={1}
            color="#000"
            speed={1}
            trail={60}
            shadow={false}
            hwaccel={false}
            className='spinner'
            zIndex={2e9}
            top="50%"
            left="50%"
            scale={1.0}
            loadedClassName="loadedContent"
          />
          <div className='advertisementcross'>
            <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
          </div>
          <div class="advertisementupperdiv">
            <small class="advertisementTitle">
              Advertisement
          </small>
          </div>
          <div>
            <div class="advertisementlowerdiv" >
              <div class="advertisementlowerin">
                <div class="advertisementContainer">
                  <div class="advertisementLeftPart">
                    <div className="imageTextContainer">
                      <p className="imageText">Image*</p>
                    </div>
                    <div className="imageTextContainer">
                      <div>
                        <Upload
                          idupload="imageUpload"
                          output="imageOutput"
                          setImageLink={this.setImageUploadLink}
                          src={this.state.imageLink}
                          isUploadDisabled={this.state.isUploadDisabled}
                          isDeleteDisabled={this.state.isDeleteDisabled}
                          handleRemove={this.removeImageUploadedLink}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="advertisementRightPart">
                    <div class="advertisementCompanyContainer">
                      <small class="adLabel">Advertising Company</small>
                      <input class="copyInput" type="text" placeholder="Enter company name" value={this.state.advertisementName} onChange={(e) => this.setState({ advertisementName: e.target.value })}></input>
                    </div>
                    <div className="fromtoContainer">
                      <div>
                        <small class="adLabel">Effective Date</small>
                        <div className="fromtoTextinput">
                          <div class="advertisementDateInput">
                            <input class="advertisementinputlbor" placeholder="DD/MM/YYYY" value={this.state.effectiveDateCalendar}></input>
                          </div>
                          <div class="advercalender">  {this.state.showEffectiveCalendar ? <div ref={this.container}>
                            <Calendar onChange={this.handleEffectiveDateChanged}
                              value={this.effectiveDateCalendar}
                              tileDisabled={({ activeStartDate, date, view }) => this.getTileStatus(date.getDate(), date.getMonth())}
                              minDate={new Date()} /></div> : null}</div>
                          <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" onClick={this.toggleEffectiveCalendar}
                          />
                        </div>
                      </div>
                      <div>
                        <small class="adLabel">Expiry Date</small>
                        <div className="fromtoTextinput">
                          <div class="advertisementDateInput">
                            <input class="advertisementinputlbor" placeholder="DD/MM/YYYY" value={this.state.expiryDateCalendar}></input>
                          </div>
                          <div class="advercalender">  {this.state.showExpiryCalendar ? <div ref={this.container}>
                            <Calendar
                              tileDisabled={({ activeStartDate, date, view }) => this.getTileStatus(date.getDate(), date.getMonth())}
                              onChange={this.handleExpiryDateChanged} value={this.expiryDateCalendar} minDate={this.state.effectiveDate.length !== 0 ? new Date(Number(this.state.effectiveDate)) :
                                (new Date() > new Date(this.state.effectiveDateFormateCopy) ? new Date() : new Date(this.state.effectiveDateFormateCopy))
                              } />
                          </div> : null}</div>
                          <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1" alt="" loading="lazy" onClick={this.toggleExpiryCalendar}
                          />
                        </div>
                      </div>
                      <div className="errordate">{this.state.errors["todate"]}</div>
                    </div>
                    <div class="advertisementUrlContainer">
                      <small class="adLabel">URL</small>
                      <input class="urlInput" placeholder="Enter your message" value={this.state.url} onChange={this.handleUrl}></input>
                      <div className="errorInvalidUrl">{this.state.errors["url"]}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="advertisementbefore">
                <div>
                  <p className="req">*Requirements:</p>
                  <pre className="reqText">
                    Type: <span className="reqValue">jpeg, jpg, png;</span> <br />
                File Size: <span className="reqValue">2 MB (Maximum);</span> <br />
                Dimensions: <span className="reqValue">1440 x 500 pixels (Minimum)</span>
                  </pre>
                </div>
                <div class="advertisementafter">
                  <button class="advertisementPublishButton"
                    onClick={this.handleSubmit}
                    disabled={!this.validateFormFields()}>
                    <small class="advertisementSubmitText">Publish</small>
                  </button>
                </div>
              </div>
            </div>
            <SubmitModal onClick={this.onPublish} hasOpen={this.state.publishHasOpen} >
              <div className="sectionTextContainer">
                <p className="sectionText">Your advertisement has been published successfully</p>
              </div>
            </SubmitModal>
            <AlertModal onClick={this.onCloseAlert} hasOpen={this.state.hasOpenAlert} >
              <div className="alertSectionTextContainer">
                <p className="alertSectionText">You have selected invalid date range as slot is not available for some of the dates for this date range. Please select different date range.</p>
              </div>
            </AlertModal>
          </div>
        </div>
      </div>
    );
  }
}
export default EditAdvertisementData;